import {PermissionCollection} from "../../../collections/Permissions";

export class VMeterPermissionCollection extends PermissionCollection {
    canCreateNewVMeterGroup = this.generatePermissionFunction('app', 'vmtrg', 'create');
    canViewVMeterGroup = this.generatePermissionFunction('vmtrg', null, 'view');
    canModifyVMeterGroup = this.generatePermissionFunction('vmtrg', null, 'modify');
    canDeleteVMeterGroup = this.generatePermissionFunction('vmtrg', null, 'delete');
}





// WEBPACK FOOTER //
// ./srv/public/js/apps/vmeter/collections/VMeterPermissions.ts